import { defineMessages } from "react-intl";

export const messages = defineMessages({
  item: {
    id: "Xz/sDf",
    defaultMessage: "Item:",
    description: "Dry run items list item",
  },
});
